// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__HFlG2","log":"ModalInventoryLogs_log__2ohX2","date":"ModalInventoryLogs_date___Mvq5","userName":"ModalInventoryLogs_userName__VRgji"};